import { api, apiN8n } from './api';

export interface IDriverKilometer {
  id?: string;
  date: string;
  km_start: number;
  km_end: number;
  km_traveled: number;
  destination: string;
  reason: string;
  observation: string;
  file?: boolean;
  file_url?: string;
}

export interface IDriverKilometerResponse {
  id: string;
  date: string;
  km_start: string;
  km_end: string;
  km_traveled: string;
  destination: string;
  reason: string;
  observation: string;
  file: boolean;
  file_url: string;
  conductor: {
    id: string;
    name: string;
  };
  created_at: string;
  updated_at: string;
}

export interface IDriverKilometersListResponse {
  driverKilometers: IDriverKilometerResponse[];
  pagination: {
    page: number;
    take: number;
    total: number;
    totalPages: number;
  };
}

export interface IDriverKilometerFilters {
  conductor_id?: string;
  date_start?: string;
  date_end?: string;
  page?: number;
  take?: number;
}

export interface IDriverKilometerCreate {
  date: string;
  km_start: number;
  km_end: number;
  km_traveled: number;
  destination: string;
  reason: string;
  observation: string;
  conductor_id: string;
}

export interface IDriverKilometerUpdate {
  date?: string;
  km_start?: number;
  km_end?: number;
  km_traveled?: number;
  destination?: string;
  reason?: string;
  observation?: string;
}

class DriverKilometersService {
  /**
   * Lista quilometragens de condutores com filtros
   */
  static async list(
    filters: IDriverKilometerFilters,
  ): Promise<IDriverKilometersListResponse> {
    const response = await apiN8n.get('/driver-kilometers/filter', {
      params: {
        conductor_id: filters.conductor_id || '',
        date_start: filters.date_start || '',
        date_end: filters.date_end || '',
        page: filters.page || 1,
        take: filters.take || 6,
      },
    });

    return response.data;
  }

  /**
   * Busca uma quilometragem específica por ID
   */
  static async getById(id: string): Promise<IDriverKilometerResponse> {
    const response = await apiN8n.get(`/driver-kilometers/show?id=${id}`);
    return response.data;
  }

  /**
   * Cria uma nova quilometragem
   */
  static async create(
    data: IDriverKilometerCreate,
  ): Promise<IDriverKilometerResponse> {
    const response = await apiN8n.post('/driver-kilometer', data);
    return response.data;
  }

  /**
   * Atualiza uma quilometragem existente
   */
  static async update(
    id: string,
    data: IDriverKilometerUpdate,
  ): Promise<IDriverKilometerResponse> {
    const response = await apiN8n.put(`/driver-kilometers?id=${id}`, data);
    return response.data;
  }

  /**
   * Deleta uma quilometragem
   */
  static async delete(id: string): Promise<void> {
    await apiN8n.delete(`/driver-kilometers?id=${id}`);
  }

  /**
   * Faz upload do comprovante de quilometragem
   */
  static async uploadFile(id: string, file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiN8n.patch(
      `/driver-kilometers/upload/file?id=${id}`,
      formData,
    );
    return response.data;
  }

  /**
   * Remove o comprovante de quilometragem
   */
  static async deleteFile(id: string): Promise<void> {
    await apiN8n.delete(`/driver-kilometers/file?id=${id}`);
  }

  /**
   * Lista todos os condutores (usuários com flag_8 = true)
   */
  static async listDrivers(): Promise<Array<{ id: string; name: string }>> {
    const response = await api.get('/accesses/');

    const filtred = response.data.filter((a: any) => a.flag_8 === true);
    return filtred;
  }
}

export default DriverKilometersService;
